<template>
  <div class="application-popup">
    <div class="header">
      <div class="field-name">{{field.label}}<span v-if="field.require" class="fg-red">*</span></div>
      <div class="field-tips">
        <div class="left-img" v-if="field.placeholder">
          <img src="../../../assets/imgs/fg_offline_notice.png">
        </div>
        <div class="right-content">{{field.placeholder}}</div>
      </div>
    </div>
    <ul>
      <li class="popup-data-item" v-for="(popupDataItem, index) in fieldDataModel" :key="index">
        <div class="popup-item-header">
          <div class="popup-data-name">{{field.label + (index + 1)}}</div>
          <div class="delete-btn" v-if="fieldDataModel.length > minPopupNum && !fieldDisabled" @click="deletePopupDataItem(index)">
            <img src="../../../assets/imgs/application/delelte.png">删除
          </div>
        </div>
        <ul class="popup-fields">
          <li>
            <application-field
              v-for="(popupField, popupFieldIndex) in field.popupFields"
              v-show="showField(popupField, applicationData, popupDataItem)"
              :key="popupFieldIndex"
              :field="popupField"
              :field-index="fieldIndex"
              :popup-name="field.popupName"
              :popup-index="index"
              :field-disabled="fieldDisabled"
              :application-data="applicationData"
              :pcd-data="pcdData"
              :ctrl-width="isAllFieldHave4Charactor ? 444 : 414"
              :group-submitted="groupSubmitted"
              @fieldValueChanged="fieldValueChanged($event, index)"
            ></application-field>
          </li>
        </ul>
      </li>
    </ul>
    <div class="footer" v-if="fieldDataModel.length < this.field.popupCount && !fieldDisabled">
      <div @click="addPopupDataItem">
        <img src="../../../assets/imgs/application/add.png">新增
      </div>
    </div>
  </div>
</template>

<script>
import extend from 'extend';
import applicationField from './application-field';
import utils from '../../../libs/utils';
import applicationFormService from '../../../services/application-form-service';

export default {
  name: 'application-popup',
  components: {
    applicationField,
  },
  props: {
    field: { // 字段对象
      type: Object,
      required: true,
      default: () => ({}),
    },
    fieldIndex: { // 字段序号，主要是用于给id
      type: Number,
      required: true,
      default: 0,
    },
    fieldDisabled: { // 字段是否禁用
      type: Boolean,
      required: true,
      default: false,
    },
    applicationData: { // 申请表填写的所有数据对象
      type: Object,
      required: true,
      default: () => ({}),
    },
    popupData: { // 弹出窗数据
      type: Array,
      default: () => ([]),
    },
    pcdData: { // 省市区数据，主要是为了保证一份，但是尽量先不使用vuex
      type: Object,
      required: true,
      default: () => ({}),
    },
    groupSubmitted: { // 组是否提交
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      fieldDataModel: [
        {}, // 默认给一个项
      ],
      minPopupNum: 1, // 最小卡片数量
    };
  },
  computed: {

    // 所有非隐藏字段的label只有4个字，要拉近输入框与字的距离
    isAllFieldHave4Charactor() {
      return this.field.popupFields.every((field) => {
        if (field.hidden) {
          return true;
        }
        return field.label.trim().length === 4;
      });
    },
  },
  methods: {

    // 字段是否隐藏
    showField: applicationFormService.showField,

    // 字段内容改变
    fieldValueChanged(changeObject, index) {
      const result = extend([], this.fieldDataModel);
      result[index] = extend({}, result[index], { [changeObject.name]: changeObject.value });
      this.fieldDataModel = result;
      this.changeDataModel();
    },

    // 添加一项
    addPopupDataItem() {
      if (this.fieldDataModel.length < this.field.popupCount) {
        const result = extend(true, [], this.fieldDataModel);
        result.push(this.getNewItemIncludeDefaultFieldData());
        this.fieldDataModel = result;
        this.changeDataModel();
      }
    },

    // 获取一个包含字段默认值的项
    getNewItemIncludeDefaultFieldData() {
      const item = {};

      this.field.popupFields.forEach((popupField) => {
        if (popupField.value) {
          item[popupField.name] = popupField.value;
        }
      });

      return item;
    },

    // 删除一项
    deletePopupDataItem(index) {
      this.$confirm(`确定要删除此${this.field.label}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const result = extend(true, [], this.fieldDataModel);
        result.splice(index, 1);
        this.fieldDataModel = result;
        this.changeDataModel();
        this.$nextTick(() => {
          utils.msg.success('删除成功!');
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 字段内容变化
    changeDataModel() {
      this.$emit('fieldValueChanged', {
        name: this.field.popupName,
        value: this.fieldDataModel,
      });
    },
  },
  watch: {
    popupData(newVal) {
      if (newVal) {
        this.fieldDataModel = extend(true, [], newVal);
      }
    },
  },
  created() {
    // if (this.popupData) {
    //   this.fieldDataModel = extend(true, [], this.popupData);
    // }

    // 如果设置了最小卡片数
    if (this.field.popupMin) {
      this.minPopupNum = this.field.popupMin;
    } else {
      this.minPopupNum = 1;
    }
  },
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';
div.application-popup {
  background-color: @bg;
  padding: 0 30px;
  width: 100%;
  margin-bottom: 20px;
  div.header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    div.field-name {
      margin-top: 20px;
      font-weight: 600;
      font-size: 14px;
      color: @text-dark;
    }
    div.field-tips {
      display: flex;
      align-items: center;
      margin-top: 10px;
      margin-bottom: 15px;
      div.left-img {
        align-self: flex-start;
        margin-top: 4px;
        width: 26px;
        height: 16px;
        padding-right: 10px;
      }
      div.right-content {
        flex: 1;
        font-size: 14px;
        line-height: 24px;
        color: @text-red;
      }
    }
  }
  ul {
    list-style-type: none;
    margin-bottom: 20px;
    li.popup-data-item {
      background-color: white;
      padding: 20px;
      border-radius: 4px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      div.popup-item-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        div.popup-data-name {
          flex: 1;
          font-size: 14px;
          color: @text-dark;
          font-weight: bold;
        }
        div.delete-btn {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 13px;
          color: @text-aaa;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
      }
    }
  }
  div.footer {
    div {
      cursor: pointer;
      font-size: 16px;
      color: @main;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      img {
        margin-right: 10px;
        width: 19px;
        height: 19px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-popup.vue